import dayjs from "dayjs";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { Typography } from "@mui/material";
import { CustomizeSpan } from "../../style";
import DropDownSelect from "../../../../component/Select";
import { CustomDiv } from "../../../chat-bot/style";
import { HandleSkeletion } from "../../../../utils/constants";
export const JobMetaView = ({ jobData, dateTime, isLoading }) => {
  const details = jobData?.data?.job_details || jobData?.job_details;
  return isLoading ? (
    <HandleSkeletion height={50} width={"50%"} />
  ) : (
    <JobMetaWrapper>
      <MetaField label="Job Owner">
        {details?.job_owner?.username || "N/A"}
      </MetaField>

      <MetaField label="Acc. Exec.">
        {details?.account_executive?.username || "N/A"}
      </MetaField>

      <MetaField label="Submission Deadline">
        {dateTime ? dayjs(dateTime).format("DD MMM YYYY, hh:mm A") : "N/A"}
      </MetaField>
    </JobMetaWrapper>
  );
};
export const JobMetaEdit = ({
  values,
  errors,
  userData,
  handleMenuItem,
  handleDataTime,
  isLoading,
}) => {
  return isLoading ? (
    <HandleSkeletion height={50} width={"50%"} />
  ) : (
    <JobMetaWrapper>
      <Typography
        variant="body2"
        fontWeight="400"
        display="flex"
        alignItems="center"
        flexDirection="row"
        gap="5px"
      >
        <CustomizeSpan fontWeight="700">Job Owner :</CustomizeSpan>
        <DropDownSelect
          marginTop="0px"
          title="Job Owner"
          removeAnimation
          data={userData}
          // error={Boolean(errors[values?.job_owner])}
          // helperText={errors[values?.job_owner] || ""}
          id="job_owner"
          value={values?.job_owner?.username || ""}
          handleChange={(e) => handleMenuItem(e, "job_owner")}
          padding="5px 10px"
          customStyle={{ width: "120px" }}
          sizeMedium="-11px"
          width="inherit"
          menuItemValue
        />
      </Typography>

      <Typography
        variant="body2"
        fontWeight="400"
        display="flex"
        alignItems="center"
        flexDirection="row"
        gap="5px"
      >
        <CustomizeSpan fontWeight="700">Acc. Exec. :</CustomizeSpan>
        <DropDownSelect
          marginTop="0px"
          title="Acc. Exec."
          removeAnimation
          data={userData}
          // error={Boolean(errors[values?.account_executive])}
          // helperText={errors[values?.account_executive] || ""}
          id="Acc. Exec."
          value={values?.account_executive?.username || ""}
          handleChange={(e) => handleMenuItem(e, "account_executive")}
          padding="5px 10px"
          customStyle={{ width: "120px" }}
          sizeMedium="-11px"
          width="inherit"
          menuItemValue
        />
      </Typography>

      {/* Submission Deadline */}
      <Typography
        variant="body2"
        fontWeight="400"
        display="flex"
        alignItems="center"
        flexDirection="row"
        gap="5px"
      >
        <CustomizeSpan fontWeight="700">Deadline :</CustomizeSpan>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            disablePast
            minDateTime={dayjs()}
            label="Submission Deadline"
            format="MMM DD YYYY hh:mm A"
            value={
              values?.submission_deadline
                ? dayjs(values.submission_deadline)
                : null
            }
            onChange={handleDataTime}
            slotProps={{
              textField: {
                error: false,
                helperText: "",
                placeholder: "Date and Time",
                fullWidth: false,
                inputProps: { readOnly: true },
                sx: {
                  marginTop: "0px",
                  width: "220px",
                  "& fieldset": {
                    border: "1px solid #D0D5DD",
                    borderRadius: "5px",
                  },
                  "& input": {
                    padding: "5px 10px",
                    fontSize: "0.875rem",
                  },
                  "& label.MuiInputLabel-sizeMedium": { top: "-9px" },
                  "& label.MuiInputLabel-shrink": { top: "0px" },
                  "& .MuiInputBase-root": {
                    height: "32px",
                  },
                  "& .MuiInputAdornment-root": {
                    marginLeft: "0px",
                  },
                },
              },
            }}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
          />
        </LocalizationProvider>
      </Typography>
    </JobMetaWrapper>
  );
};

export const JobMetaInfo = ({ mode = "view", ...props }) => {
  if (mode === "edit") {
    return <JobMetaEdit {...props} />;
  }
  return <JobMetaView {...props} />;
};

const JobMetaWrapper = ({ children }) => (
  <CustomDiv
    display="flex"
    gap="0.5rem"
    padding="5px 10px"
    customStyle={{ flexDirection: "row" }}
    alignItems="center"
    borderRadius="6px"
    border="1px solid #EAECF0"
    width="fit-content"
    flexWrap="wrap"
  >
    {children}
  </CustomDiv>
);

const MetaField = ({ label, children }) => (
  <Typography
    variant="body2"
    fontWeight="400"
    display="flex"
    alignItems="center"
    flexDirection="row"
    gap="5px"
  >
    <span style={{ fontWeight: 700 }}>{label} :</span>
    {children}
  </Typography>
);
